import { css } from 'styled-components';
import { TypographyName, getTypography, getSpacing, SpacingName } from '../../theme';
export const modalFooterStyle = _ref => {
  let {
    theme,
    $padded
  } = _ref;
  return css(["", " border-top:1px solid ", ";background-color:", ";display:flex;justify-content:flex-end;align-items:center;flex-shrink:0;", ""], getTypography(theme, TypographyName.BODY), theme.palettes.neutrals.light, theme.palettes.neutrals.lightest, $padded ? getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.MEDIUM]) : '');
};
//# sourceMappingURL=ModalFooter.style.js.map